export default "__VITE_ASSET__DApfA6c$__"